import { render, staticRenderFns } from "./ReportsHistory.vue?vue&type=template&id=d62ab26e&scoped=true&"
import script from "./ReportsHistory.vue?vue&type=script&lang=js&"
export * from "./ReportsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportsHistory.vue?vue&type=style&index=0&id=d62ab26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62ab26e",
  null
  
)

export default component.exports
import {QBtn,QBadge,QItem,QInput,QSeparator,QSpinnerDots,QExpansionItem,QItemSection,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QBtn,QBadge,QItem,QInput,QSeparator,QSpinnerDots,QExpansionItem,QItemSection,QInnerLoading,QSpinnerGears}, component.options.components || {})
